/**
 * Search form
 */

(function($) {
    $(document).ready(function(){

        function excecute_highlight() {
            $('.search-form__input').blur();
            $(".entry__content *").unhighlight();

            var original_query = $('.search-form__input').val();

            $('#search-sticky-query').text(original_query);

            if (original_query !== "") {
                $(".entry__content *").highlight(original_query);
            }
            var query_results = $('.highlight').length;

            // update amount in sticky
            $('#seach-nav-total').text(query_results);

            if(query_results < 1) {
                $('.no-results').fadeIn(150);
                $('#search-results-nav').removeClass('show');
            } else {
                $('#search-results-nav').addClass('show');
                $('.no-results').fadeOut(150);
            }
            // ekaan, pitäisi päästä myös seuraaviin

            var $first_result = $('.highlight').first();
            $first_result.addClass('active');

            $('#search-nav-current').text(1);

            $('html, body').animate({
                scrollTop: $first_result.offset().top - 10
            }, 650);
        }

        // Search in page
        $('.search-button').click(function () {
            $('.no-results').fadeOut(150);
            excecute_highlight();
        });

        // Search on enter key press
        $('.search-form__input').keyup(function(e){
            if(e.keyCode === 13) {
                $('.no-results').fadeOut(150);
                excecute_highlight();
            } else {
                $(".entry__content *").unhighlight();
            }

            // count occurances
            var original_query = $('.search-form__input').val();
            if (original_query !== "" && original_query.length > 1) {
                $(".entry__content *").highlight(original_query, {
                    className: 'highlight-count'
                });

                var highlight_count = $('.highlight-count').length;

                show_result_count(highlight_count, false);

                //$(".highlight-count").contents().unwrap();
                $(".entry__content *").unhighlight({ className: 'highlight-count' });


            } else {
                $('.result-count').removeClass('show');
            }

        });

        function show_result_count(results, should_hide_result) {
            $('#count-nmb').text(results);
            $('.result-count').addClass('show');
            $('.result-count-options').removeClass('show');

            if(results == 0) {
                $('#count-no-results').addClass('show');
            } else if(results == 1) {
                $('#count-one-result').addClass('show');
            } else {
                $('#count-many-results').addClass('show');
            }
        }

        $('#next-result').click(function (e) {
            var $highlights = $('.highlight');
            var $active = $('.highlight.active');
        
            // get element after 'active'
            if($highlights.length && $active.length) {
        
                var active_found = false;
                var next_item_num = -1;
            
                $highlights.each(function( i ) {
                    if(active_found == true) {
                        next_item_num = i;
                        return false;
                    }
                    if($(this).hasClass('active')) {
                        active_found = true;
                    }
                });
        
        
                // last item active, jump to first
                if(next_item_num == -1) {
                    next_item_num = 0;
                }
        
                $('#search-nav-current').text(next_item_num + 1);
                $($highlights[next_item_num]).addClass('active');
                $('.highlight.active').removeClass('active');
            
                $('html, body').animate({
                    scrollTop: $($highlights[next_item_num]).offset().top - 10
                }, 500);
            
                $($highlights[next_item_num]).addClass('active');
            }
        
        });
        
        $('#prev-result').click(function (e) {
            var $highlights = $('.highlight');
            var $active = $('.highlight.active');
        
            // get element after 'active'
            if($highlights.length && $active.length) {
        
                var active_found = false;
                var next_item_num = -1;
            
                $highlights.each(function( i ) {
                if($(this).hasClass('active')) {
                    next_item_num = i - 1;
                    return false;
                }
                });
            
            
                // last item active, jump to first
                if(next_item_num == -1) {
                next_item_num = $highlights.length - 1;
                }
            
                $('#search-nav-current').text(next_item_num + 1);
                $($highlights[next_item_num]).addClass('active');
                $('.highlight.active').removeClass('active');
            
            
                $('html, body').animate({
                scrollTop: $($highlights[next_item_num]).offset().top - 10
                }, 500);
            
                $($highlights[next_item_num]).addClass('active');
            }
        
        });
        
        $('#results-close').click(function() {
            $('#search-results-nav').removeClass('show');
            $(".entry__content *").unhighlight();
        });
        
        function close_search() {
            $('#search-results-nav').removeClass('show');
            $(".entry__content *").unhighlight();
        }
        
        // Search tools & keyboard
        $(document).keyup(function(e) {
            if (e.keyCode == 27) { // escape key
                close_search();
            }
            
            if (e.keyCode == 39 || e.keyCode == 40) { // right or down
                if($('#search-results-nav').hasClass('show')) {
                $('#next-result').trigger('click');
                }
            }
            
            if (e.keyCode == 37 || e.keyCode == 38) { // left or up
                if($('#search-results-nav').hasClass('show')) {
                $('#prev-result').trigger('click');
                }
            }
        });
        
        $('.search-form__input').focus(function() {
            close_search();
        });
    });
})(jQuery);
